<template>
  <div class="personnel_management_container">
    <div class="header">
      <div class="header_left">
        <a-input v-model:value="searchKeywords" placeholder="请输入助教信息" @keyup.enter="handleSearchKeywords">
          <template #suffix>
            <img
              src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/4f335c6bd8924a9980e301ed818df3c5.png"
              alt="搜索"
              style="cursor: pointer"
              @click="handleSearchKeywords"
            />
          </template>
        </a-input>
      </div>
      <div class="header_right">
        <a-button type="primary" class="add_course_btn" @click="handlePersonnel()">
          <a-icon type="plus-circle" theme="filled" />
          添加助教
        </a-button>
      </div>
    </div>
    <div class="body">
      <a-table
        :columns="personnelColumns"
        :data-source="personnelList"
        :pagination="pagination"
        :loading="loading"
        :row-key="(record) => record.liveId"
        @change="handleTableChange"
        :customRow="customRow"
      >
        <div slot="action" slot-scope="text, record" class="action_box" v-if="false">
          <!-- <a-tooltip placement="top" :overlayStyle="{ width: '45px' }">
            <template slot="title">
              <span>编辑</span>
            </template>
            <img
              src="@/assets/img/liveStreaming/edit.png"
              alt="edit"
              class="action_box_item"
              @click.stop="handleAction(record, 'edit')"
            />
          </a-tooltip> -->
          <!-- <a-tooltip placement="top" :overlayStyle="{ width: '45px' }">
            <template slot="title">
              <span>删除</span>
            </template>
            <img
              src="@/assets/img/liveStreaming/delete.png"
              alt="delete"
              class="action_box_item"
              @click.stop="handleAction(record, 'delete')"
            />
          </a-tooltip> -->
        </div>
      </a-table>
    </div>
    <!-- personnel dialog -->
    <personnel-dialog
      :personnelDialogFlag.sync="personnelDialogFlag"
      :rowDetail="rowDetail"
      :title="Object.keys(rowDetail).length ? '编辑助教' : '添加助教'"
      :personnelType="2"
      :roleOptionsFromFather="[]"
      :schoolListFromFather="[]"
      @getPersonnelList="getPersonnelList"
    />
    <!-- delete dialog -->
    <delete-dialog
      :deleteDialogFlag.sync="deleteDialogFlag"
      :rowDetail="rowDetail"
      @getPersonnelList="getPersonnelList"
      :personnelType="2"
    />
  </div>
</template>

<script>
export default {
  name: 'PersonnelManagement',
  components: {
    'personnel-dialog': () => import('../comp/PersonnelDialog.vue'),
    'delete-dialog': () => import('../comp/DeleteDialog.vue')
  },
  data() {
    return {
      searchKeywords: '',
      personnelColumns: [
        {
          title: '姓名',
          dataIndex: 'userName',
          key: 'userName',
          scopedSlots: { customRender: 'userName' },
          align: 'left'
        },
        {
          title: '用户ID',
          dataIndex: 'userId',
          key: 'userId',
          scopedSlots: { customRender: 'userId' },
          align: 'left'
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          key: 'phone',
          scopedSlots: { customRender: 'phone' },
          align: 'left'
        }
        // {
        //   title: '操作',
        //   key: 'action',
        //   scopedSlots: { customRender: 'action' },
        //   align: 'right',
        //   width: '80px'
        // }
      ],
      personnelList: [],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['50', '100', '150', '200'],
        showTotal: (total) => `共 ${total} 条`
      },
      loading: false,
      personnelDialogFlag: false,
      rowDetail: {},
      deleteDialogFlag: false
    }
  },
  methods: {
    handleSchoolChange(value) {
      this.schoolCode = value
      this.pagination.current = 1
      this.getPersonnelList()
    },
    handleSearchKeywords() {
      this.pagination.current = 1
      this.getPersonnelList()
    },
    handlePersonnel() {
      this.rowDetail = {}
      this.personnelDialogFlag = true
    },
    async getPersonnelList() {
      try {
        const params = {
          keywords: this.searchKeywords,
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize
        }
        this.loading = true
        const result = await this.$http.assistantList(params)
        this.loading = false
        if (result.code !== 200) return this.$message.error(result.msg)
        const { rt: resultReally } = result
        if (resultReally.resultStatus !== 1) return this.$message.error(resultReally.resultMessage)
        this.personnelList = resultReally.list || []
        this.pagination.total = resultReally.totalCount
        if (!this.personnelList.length && Math.floor(this.pagination.total / this.pagination.pageSize) >= 1) {
          this.pagination.current -= 1
          this.getPersonnelList()
        }
      } catch (err) {
        console.log(err)
      }
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getPersonnelList()
    },
    customRow(record, index) {
      return {
        on: {
          click: (event) => {
            this.rowClick(record, index, event)
          }
        }
      }
    },
    async rowClick(record, index, event) {
      console.log(record, index, event, 'record')
    },
    handleAction(record, action) {
      this.rowDetail = record
      switch (action) {
        case 'edit':
          this.personnelDialogFlag = true
          break
        case 'delete':
          this.deleteDialogFlag = true
          break
      }
    }
  },
  async created() {
    this.getPersonnelList()
  }
}
</script>

<style lang="scss" scoped>
.personnel_management_container {
  width: 100%;
  height: auto;
  text-align: left;
  .header {
    width: 100%;
    height: 64px;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    .header_left {
      ::v-deep.ant-input-affix-wrapper {
        width: 240px;
        .ant-input-suffix {
          img {
            width: 20px;
            height: 20px;
            display: block;
          }
        }
      }
    }
    .header_right {
      ::v-deep.ant-btn-primary {
        background-color: #5f60d3;
        border-color: #5f60d3;
      }
    }
  }
  .body {
    width: 100%;
    height: auto;
    background-color: #ffffff;
    margin-top: 16px;
    padding: 16px;
    .action_box {
      width: 120px;
      display: flex;
      justify-content: flex-end;
      .action_box_item {
        display: block;
        width: 16px;
        height: 16px;
        margin-right: 12px;
        cursor: pointer;
        &:nth-last-child(1) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
